import React from 'react';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Michael R.',
    location: 'Macomb, MI',
    text: 'Moceri replaced our old shingle roof in two days. The crew was professional, the price matched the quote exactly, and the cleanup was immaculate. Highly recommend!'
  }, {
    name: 'Sarah T.',
    location: 'Troy, MI',
    text: 'After getting ghosted by two other contractors, Moceri was a breath of fresh air. Showed up on time, gave a fair quote, and the new shingle roof looks fantastic on our colonial.'
  }, {
    name: 'David L.',
    location: 'Sterling Heights, MI',
    text: 'Quality work from start to finish. They explained everything, helped us pick the right shingle color, and got it done before winter hit. No more ice dam issues!'
  }];
  return <section className="bg-slate-50 py-20 sm:py-24" data-id="element-320" data-mp="qac3n4eykj2i">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-321" data-mp="qbn52xkxleqg">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-322" data-mp="h5f0hpouu32s">
          <span className="inline-block text-[#2DB8E0] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-323" data-mp="h818trjkkmm2">
            Reviews
          </span>
          <h2 className="font-display italic text-4xl sm:text-5xl text-[#1a2332] leading-tight mb-4" data-id="element-324" data-mp="78a9nck2djfn">
            Trusted by Michigan Homeowners
          </h2>
          <div className="flex justify-center items-center gap-2 text-yellow-400" data-id="element-325" data-mp="c8y3s73lage3">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-326" data-mp="14v9bs2tizjkx" />)}
            <span className="ml-2 text-slate-700 font-semibold" data-id="element-327" data-mp="14xdckbw4o2gz">
              5.0 average rating
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-328" data-mp="v4o4zs3p78qx">
          {reviews.map(r => <div key={r.name} className="bg-white rounded-xl p-7 shadow-sm border border-slate-100 relative" data-id="element-329" data-mp="1iv1yzo5ufho5">
              <Quote className="absolute top-5 right-5 w-8 h-8 text-[#2DB8E0]/20" data-id="element-330" data-mp="1no3g82tivtaw" />
              <div className="flex text-yellow-400 mb-4" data-id="element-331" data-mp="1xhh841b51lob">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-332" data-mp="1sjpbwv3gndeb" />)}
              </div>
              <p className="text-slate-700 mb-6 leading-relaxed" data-id="element-333" data-mp="1ojf91rayt33o">"{r.text}"</p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100" data-id="element-334" data-mp="1jhpwg783ghdh">
                <div className="w-10 h-10 bg-[#2DB8E0]/10 rounded-full flex items-center justify-center font-bold text-[#1a9cc4]" data-id="element-335" data-mp="1ejwrfhij1tes">
                  {r.name.charAt(0)}
                </div>
                <div data-id="element-336" data-mp="14ud7e8j2vtic">
                  <div className="font-bold text-[#1a2332]" data-id="element-337" data-mp="14tv0mhyshww6">{r.name}</div>
                  <div className="text-sm text-slate-500" data-id="element-338" data-mp="10srn4247scy4">{r.location}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}